import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { SolarComputePreviewDto } from "../dto/solar-proposal-compute.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** As the product offering's preview: the gateway keeps PowurOS inputs for 30 minutes. */
const PREVIEW_STALE_TIME_MS = 30_000

/** The AI compute nodes PowurOS offers the proposal, with what each would earn. Side-effect free. */
export default function useSolarComputePreview(
  proposalId: string | undefined,
  options?: { enabled?: boolean },
): UseQueryResult<SolarComputePreviewDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.computePreview(proposalId ?? ``),
    queryFn: ({ signal }) =>
      solarProposalService.previewCompute(proposalId ?? ``, signal),
    enabled: Boolean(proposalId) && (options?.enabled ?? true),
    staleTime: PREVIEW_STALE_TIME_MS,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
